var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErgoLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3",
    "data-name": "Group 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 163.359,
    height: 109.01,
    viewBox: "0 0 163.359 109.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 163.358,
    height: 109.01,
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 163.357,
    height: 14.262,
    transform: "translate(0.001 94.748)",
    fill: "#6a6c6c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M199.366,153.617h-3.848V162.9h2.132v-3.77h1.582c2.5,0,2.844-1.675,2.844-2.736,0-1.689-.763-2.776-2.71-2.776m-.521,4.078h-1.2v-2.642h1.073c.966,0,1.194.643,1.194,1.4a1.188,1.188,0,0,1-1.071,1.247",
    transform: "translate(-71.722 -56.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M165.755,160.2c0,1.386-.865,2.856-3.465,2.856-2.341,0-3.472-1.106-3.472-2.856v-6.579h2.131v6.455c0,1.142.536,1.591,1.315,1.591.932,0,1.353-.566,1.353-1.591v-6.455h2.138Z",
    transform: "translate(-58.259 -56.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M125.866,153.386c-3.513,0-3.513,2.333-3.513,4.8,0,2.415,0,4.788,3.513,4.788s3.513-2.373,3.513-4.788c0-2.468,0-4.8-3.513-4.8m0,8.2c-1.207,0-1.355-1.034-1.355-3.394,0-2.387.148-3.407,1.355-3.407s1.355,1.02,1.355,3.407c0,2.36-.161,3.394-1.355,3.394",
    transform: "translate(-44.883 -56.267)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M92.631,160.178a1.747,1.747,0,0,0-1.85-1.825v-.027a2.04,2.04,0,0,0,1.891-2.279,2.211,2.211,0,0,0-2.388-2.428H86.342V162.9h2.133v-3.836h.548c1.637,0,1.529.938,1.529,2.037a3.9,3.9,0,0,0,.229,1.8h2.093a11.327,11.327,0,0,1-.243-2.723m-3.205-2.549h-.952v-2.574h.952c.671,0,1.086.336,1.086,1.219,0,.59-.241,1.355-1.086,1.355",
    transform: "translate(-31.673 -56.352)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M53.351,161.624a3.562,3.562,0,0,0,1.057-.182v-2.057h-1.16v-1.428h3.294v4.7a21.22,21.22,0,0,1-2.885.313c-3.583,0-3.993-1.347-3.993-4.87,0-2.338.126-4.716,3.612-4.716,2.092,0,3.393,1.068,3.265,3.007H54.424c.015-.861-.143-1.618-1.273-1.618-1.326,0-1.326,1.631-1.326,3.431,0,2.9.308,3.418,1.526,3.418",
    transform: "translate(-18.219 -56.266)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M36.778,131.953c0,1.8,0,1.908,1.278,2.064v.553H33.834v-.553c1.259-.155,1.259-.268,1.259-2.064v-4.1c-.054-1.016-.075-1.377-1.238-1.377v-.46l2.923-1.126v2.255c.728-.9,1.871-2.255,3.131-2.255A1.129,1.129,0,0,1,41.1,126a1.015,1.015,0,0,1-1.034,1.068c-.669,0-.917-.5-1.529-.5-.666,0-1.431.878-1.755,1.413Z",
    transform: "translate(-12.411 -45.812)",
    fill: "#6a6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M8.137,127.575H7.583c.021-2.445-1.621-2.559-3.131-2.466H3.67v4.413c0,1.549.21,1.929,1.946,1.929,3.115,0,3.672-.782,5.575-3.191l.46.194-1.413,3.627H0v-.631c1.51,0,1.779-.5,1.779-2.614v-7.491c0-2.1-.269-2.614-1.779-2.614V118.1H9.992l1.337,3.262-.477.289c-1.682-2.236-2.314-2.922-5.122-2.922-1.944,0-2.06.3-2.06,2.177v3.572h.783c1.794,0,3.018-.327,3.152-2.389h.532Z",
    transform: "translate(0 -43.324)",
    fill: "#6a6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M64.471,125.673c-1.455,0-1.986,1.642-1.986,2.846,0,1.263.573,2.692,2.026,2.692,1.43,0,1.851-1.454,1.851-2.636,0-1.107-.5-2.9-1.891-2.9m-.916,8.6c-.783.245-2.178.666-2.178,1.7,0,1.259,2.3,1.357,3.263,1.357.863,0,2.886-.116,2.886-1.208,0-.705-.86-.952-1.4-1.126Zm1.85-1.033c1.284.324,3.554.631,3.554,2.368,0,2.1-2.923,2.347-4.528,2.347-1.24,0-4.733-.172-4.733-1.906,0-1.357,1.927-1.683,2.88-2.007-.553-.211-1.983-.537-1.983-1.358,0-.8,1.031-1.24,1.7-1.392a3.3,3.3,0,0,1-1.624-2.9,3.576,3.576,0,0,1,3.842-3.344,3.745,3.745,0,0,1,2.555.916,3.019,3.019,0,0,1,1.97-1.013.98.98,0,0,1,.974,1.029.868.868,0,0,1-.783.918c-.7,0-.785-.763-1.453-.763a.586.586,0,0,0-.363.173,3.24,3.24,0,0,1,.765,2.2,3.59,3.59,0,0,1-3.746,3.343,4.548,4.548,0,0,1-1.581-.286c-.213.074-.557.187-.557.474,0,.516,1.262.745,1.605.842l1.507.363",
    transform: "translate(-21.899 -45.834)",
    fill: "#6a6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M98.245,129.758c0-1.4-.438-4.028-2.309-4.028-1.931,0-2.41,2.519-2.41,3.993,0,1.358.439,4.507,2.3,4.507,1.986,0,2.423-3,2.423-4.471m-6.646.384c0-2.485,1.641-5.041,4.338-5.041,2.654,0,4.235,2.6,4.235,5.022a4.577,4.577,0,0,1-4.349,4.738c-2.447,0-4.223-2.369-4.223-4.718",
    transform: "translate(-33.601 -45.89)",
    fill: "#6a6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M124.362,131.953c0,1.8,0,1.908,1.281,2.064v.553h-4.261v-.553c1.3-.155,1.3-.268,1.3-2.064v-4.1c-.061-1.016-.078-1.377-1.239-1.377v-.46l2.918-1.126v1.625a4.538,4.538,0,0,1,3-1.489,2.6,2.6,0,0,1,1.813.745,3.455,3.455,0,0,1,.648,2.485v3.7c0,1.8,0,1.908,1.281,2.064v.553h-4.279v-.553c1.319-.155,1.319-.268,1.319-2.064v-3.342c0-1.147-.075-2.576-1.584-2.576a3.508,3.508,0,0,0-2.2,1.258Z",
    transform: "translate(-44.527 -45.812)",
    fill: "#6a6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M159.51,129.758c0-1.4-.441-4.028-2.314-4.028-1.929,0-2.407,2.519-2.407,3.993,0,1.358.442,4.507,2.3,4.507,1.982,0,2.423-3,2.423-4.471m-6.646.384c0-2.485,1.642-5.041,4.333-5.041,2.654,0,4.24,2.6,4.24,5.022a4.576,4.576,0,0,1-4.349,4.738c-2.445,0-4.223-2.369-4.223-4.718",
    transform: "translate(-56.075 -45.89)",
    fill: "#6a6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M185.631,131.953c0,1.8,0,1.908,1.3,2.064v.553h-4.275v-.553c1.3-.155,1.3-.268,1.3-2.064v-4.1c-.057-1.016-.075-1.377-1.241-1.377v-.46l2.923-1.126v1.889a4.169,4.169,0,0,1,3.166-1.754,2.459,2.459,0,0,1,2.272,1.754,4.8,4.8,0,0,1,3.272-1.754,2.207,2.207,0,0,1,2.036,1.05,5.46,5.46,0,0,1,.406,2.633v3.249c0,1.8,0,1.908,1.281,2.064v.553H193.8v-.553c1.3-.155,1.3-.268,1.3-2.064v-3.417c0-1.033.02-2.5-1.4-2.5a3.673,3.673,0,0,0-2.5,1.39v4.528c0,1.8,0,1.908,1.3,2.064v.553h-4.259v-.553c1.276-.155,1.276-.268,1.276-2.064v-3.417c0-1.033-.03-2.5-1.446-2.5a3.427,3.427,0,0,0-2.445,1.39Z",
    transform: "translate(-67.002 -45.812)",
    fill: "#6a6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M224.311,120.307a1.27,1.27,0,0,1-.018-2.539,1.27,1.27,0,1,1,.018,2.539m1.092,9.035c0,1.8,0,1.908,1.3,2.064v.553h-4.275v-.576c1.3-.148,1.3-.286,1.3-2.06v-4.085c-.06-1.016-.075-1.377-1.244-1.377v-.46l2.927-1.126v7.067",
    transform: "translate(-81.592 -43.201)",
    fill: "#6a6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M253.186,132.378a4.923,4.923,0,0,1-4.035,2.481,4.5,4.5,0,0,1-4.273-4.64,4.837,4.837,0,0,1,4.867-5.119c1.089,0,3.135.666,3.135,2a.99.99,0,0,1-1.031.957c-1.415,0-.863-2.333-2.7-2.333-1.967,0-2.349,2.6-2.349,4.07,0,1.815,1.018,4.048,3.138,4.048a4.057,4.057,0,0,0,2.957-1.737Z",
    transform: "translate(-89.828 -45.891)",
    fill: "#6a6c6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M139.375,38.961A28.459,28.459,0,1,1,110.917,10.5a28.46,28.46,0,0,1,28.458,28.458",
    transform: "translate(-30.248 -3.853)",
    fill: "#007d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M126.316,52.4h-.763c.027-3.36-2.229-3.517-4.3-3.384h-1.077v6.062c0,2.126.287,2.649,2.676,2.649,4.278,0,5.037-1.074,7.663-4.383l.627.263L129.2,58.6H115.135v-.868c2.073,0,2.441-.683,2.441-3.6V43.849c0-2.886-.368-3.6-2.441-3.6v-.864h13.727l1.834,4.488-.655.4c-2.307-3.072-3.177-4.019-7.034-4.019-2.676,0-2.832.42-2.832,2.993v4.907h1.077c2.464,0,4.145-.447,4.328-3.28h.736Z",
    transform: "translate(-42.235 -14.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M105.761,13.9l-1.158.316,1.629,6.085,1.168-.307Zm12.834.009L116.957,20l1.168.308,1.63-6.1ZM99.173,16.449l-1.034.6,3.155,5.47,1.034-.6Zm26,.009-3.156,5.471,1.045.6,3.154-5.47ZM93.488,20.618l-.85.85,4.457,4.458.85-.841Zm37.37.022L126.4,25.095l.85.85,4.456-4.456ZM89.063,26.119l-.605,1.045L93.93,30.32l.594-1.045Zm46.221.031-5.47,3.146.6,1.045,5.459-3.155ZM86.216,32.583,85.9,33.741l6.094,1.628.318-1.157Zm51.9.022-6.094,1.639.318,1.157,6.085-1.639ZM91.992,44.937,85.9,46.576l.308,1.158L92.3,46.1Zm40.34.03-.306,1.158,6.085,1.63.318-1.159ZM93.909,50l-5.46,3.156.6,1.043,5.459-3.154Zm36.487.021-.593,1.045,5.471,3.154.593-1.045ZM97.074,54.382l-4.458,4.467.852.848,4.456-4.465Zm30.157.03-.85.841,4.467,4.465.839-.85ZM101.273,57.8l-3.154,5.47,1.034.594,3.156-5.46Zm21.759.021L122,58.418l3.156,5.469,1.035-.6Zm-16.821,2.2-1.639,6.094,1.159.308,1.637-6.1Zm11.883.009-1.157.306,1.628,6.1,1.168-.308Z",
    transform: "translate(-31.51 -5.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M105.633,87.209l.533.952A31.2,31.2,0,0,1,78.455,60.3l.944.512a30.294,30.294,0,0,0,26.234,26.4",
    transform: "translate(-28.78 -22.119)",
    fill: "#007d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M79.437,33.773l-.933.419A31.16,31.16,0,0,1,106.265,6.5l-.6.954A30.277,30.277,0,0,0,79.437,33.773",
    transform: "translate(-28.798 -2.386)",
    fill: "#007d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M160.126,60.865a31.183,31.183,0,0,1-27.811,27.526l.542-.954a30.287,30.287,0,0,0,26.337-26.153Z",
    transform: "translate(-48.537 -22.327)",
    fill: "#007d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M133.035,7.458l-.543-.954a31.188,31.188,0,0,1,27.719,27.628l-.952-.512A30.268,30.268,0,0,0,133.035,7.458",
    transform: "translate(-48.602 -2.386)",
    fill: "#007d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M129.365,8.308,125.35,6.853V16.83h-1.476V6.843l-4.067,1.465.933-1.076c.113-.123.215-.255.327-.4.155-.2.308-.4.451-.614.287-.41.564-.841.829-1.3a26.9,26.9,0,0,0,1.9-3.985L124.592,0l.337.932a26.637,26.637,0,0,0,1.886,3.985,14.665,14.665,0,0,0,.84,1.3,6.84,6.84,0,0,0,.439.6h.011c.1.144.215.278.327.41Z",
    transform: "translate(-43.949)",
    fill: "#eeb600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M129.365,92.718l-.933,1.076c-.122.144-.245.287-.369.45s-.267.349-.389.534c-.306.431-.605.89-.881,1.361a27.262,27.262,0,0,0-1.865,3.954l-.337.932-.348-.932a27.341,27.341,0,0,0-1.875-3.954c-.266-.471-.553-.912-.84-1.333-.144-.2-.287-.4-.431-.572-.123-.153-.236-.3-.358-.441l-.933-1.076,4.067,1.476V84.226h1.476v9.947Z",
    transform: "translate(-43.949 -30.897)",
    fill: "#eeb600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M88.8,51.9v1.486H78.839L80.292,57.4l-1.076-.933c-.132-.113-.276-.224-.42-.337-.184-.155-.389-.3-.593-.441-.41-.3-.85-.574-1.3-.84a26.885,26.885,0,0,0-3.985-1.886l-.933-.347.933-.349A26.7,26.7,0,0,0,76.9,50.38c.451-.266.892-.542,1.3-.839a5.284,5.284,0,0,0,.6-.442c.143-.1.277-.215.41-.327l1.066-.933L78.818,51.9Z",
    transform: "translate(-26.406 -17.549)",
    fill: "#eeb600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M126.316,52.4h-.763c.027-3.36-2.229-3.517-4.3-3.384h-1.077v6.062c0,2.126.287,2.649,2.676,2.649,4.278,0,5.037-1.074,7.663-4.383l.627.263L129.2,58.6H115.135v-.868c2.073,0,2.441-.683,2.441-3.6V43.849c0-2.886-.368-3.6-2.441-3.6v-.864h13.727l1.834,4.488-.655.4c-2.307-3.072-3.177-4.019-7.034-4.019-2.676,0-2.832.42-2.832,2.993v4.907h1.077c2.464,0,4.145-.447,4.328-3.28h.736Z",
    transform: "translate(-42.235 -14.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M105.761,13.9l-1.158.316,1.629,6.085,1.168-.307Zm12.834.009L116.957,20l1.168.308,1.63-6.1ZM99.173,16.449l-1.034.6,3.155,5.47,1.034-.6Zm26,.009-3.156,5.471,1.045.6,3.154-5.47ZM93.488,20.618l-.85.85,4.457,4.458.85-.841Zm37.37.022L126.4,25.095l.85.85,4.456-4.456ZM89.063,26.119l-.605,1.045L93.93,30.32l.594-1.045Zm46.221.031-5.47,3.146.6,1.045,5.459-3.155ZM86.216,32.583,85.9,33.741l6.094,1.628.318-1.157Zm51.9.022-6.094,1.639.318,1.157,6.085-1.639ZM91.992,44.937,85.9,46.576l.308,1.158L92.3,46.1Zm40.34.03-.306,1.158,6.085,1.63.318-1.159ZM93.909,50l-5.46,3.156.6,1.043,5.459-3.154Zm36.487.021-.593,1.045,5.471,3.154.593-1.045ZM97.074,54.382l-4.458,4.467.852.848,4.456-4.465Zm30.157.03-.85.841,4.467,4.465.839-.85ZM101.273,57.8l-3.154,5.47,1.034.594,3.156-5.46Zm21.759.021L122,58.418l3.156,5.469,1.035-.6Zm-16.821,2.2-1.639,6.094,1.159.308,1.637-6.1Zm11.883.009-1.157.306,1.628,6.1,1.168-.308Z",
    transform: "translate(-31.51 -5.099)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M172.993,52.614l-.921.348a26.747,26.747,0,0,0-3.955,1.865c-.306.174-.615.367-.9.551-.348.237-.687.472-.993.708v.01a5.548,5.548,0,0,0-.462.368L164.7,57.4l1.455-4.015h-9.959V51.9h9.968L164.7,47.841l1.064.933c.144.122.3.245.462.368a11.868,11.868,0,0,0,.993.707c.286.2.594.379.9.553a26.276,26.276,0,0,0,3.955,1.865Z",
    transform: "translate(-57.296 -17.549)",
    fill: "#eeb600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M117.112,25.421v.728h-.276a18.264,18.264,0,0,1,17.772,17.783v-.267h.739a19.011,19.011,0,0,0-18.235-18.244m17.5,19.73v-.276a18.256,18.256,0,0,1-17.5,17.772v.738A19.016,19.016,0,0,0,135.347,45.15Zm.739-1.486a19.011,19.011,0,0,0-18.235-18.244c-.246-.021-.491-.021-.747-.021s-.492,0-.728.011A19.038,19.038,0,0,0,97.373,43.664c-.022.247-.022.493-.022.738s0,.5.022.748a19.029,19.029,0,0,0,18.264,18.244c.236.011.481.011.728.011s.5,0,.747-.021A19.016,19.016,0,0,0,135.347,45.15c.019-.247.019-.492.019-.748s0-.491-.019-.738M117.112,62.647c-.246.022-.5.022-.747.022s-.481,0-.728-.022A18.263,18.263,0,0,1,98.11,44.874c-.01-.154-.01-.318-.01-.472s0-.317.01-.471a18.275,18.275,0,0,1,17.784-17.783c.153-.011.318-.011.471-.011s.318,0,.471.011a18.264,18.264,0,0,1,17.772,17.783c.011.154.011.318.011.471s0,.318-.011.472a18.256,18.256,0,0,1-17.5,17.772m17.5-17.5v-.276a18.256,18.256,0,0,1-17.5,17.772v.738A19.016,19.016,0,0,0,135.347,45.15Zm0,0v-.276a18.256,18.256,0,0,1-17.5,17.772v.738A19.016,19.016,0,0,0,135.347,45.15Z",
    transform: "translate(-35.711 -9.317)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErgoLogo);
export default __webpack_public_path__ + "static/media/ergo-logo.f0241a77271adca503f329234b2dd1da.svg";
export { ForwardRef as ReactComponent };